import React from 'react';
import { useSelector } from 'react-redux';
import { getRequestUrl } from 'services/api/connector';
import { useIntl } from 'react-intl';

import copyToClipboard from 'utils/clipboard';
import { CopyApiLinkWrapper, CopyApiLinkIcon } from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Title/components/CopyApiLink/styled';
import { selectVulnDetailId } from 'store/ManageGeneral/selectors';

const CopyApiLink = () => {
  const intl = useIntl();
  const title = intl.formatMessage({ id: 'manage.detail.tab.copyApiLink' });
  const vulnId = useSelector(selectVulnDetailId);

  const copyApiLink = () => {
    if (vulnId) {
      const vulnPath = `vulns/${vulnId}`;
      const link = getRequestUrl(vulnPath);
      copyToClipboard(link);
    }
  };

  return (
    <CopyApiLinkWrapper title={ title } onClick={ copyApiLink }>
      <CopyApiLinkIcon />
    </CopyApiLinkWrapper>
  );
};

export default CopyApiLink;
